// extracted by mini-css-extract-plugin
module.exports = {"modal":"revoke-modal_modal__6eu1w","footer":"revoke-modal_footer__5PpVD"};